import { useSelectedThreatProfileQuery } from './useSelectedThreatProfileQuery'
import { useListThreatProfileEventsQuery } from './useListThreatProfileEventsQuery'

export const useSelectedThreatProfileEventsQuery = options => {
  const { data: profile } = useSelectedThreatProfileQuery()
  return useListThreatProfileEventsQuery(profile?.name, options)
}
